export const isUserBlocked = (arr, userId) => {
    if(arr.length === 0) return false
    const newArr = arr.map(item => item.id)
    return newArr.includes(userId)
}